/**
 * ヘッダーを固定する
 */

import $ from 'jquery'
import {
  $body,
} from './globals.js'

const $fixedHeader = $('.js-header-fixed');
let headerHeight = $fixedHeader.outerHeight(true);
let fixedClass = 'is-header-fixed';

// $fixedHeader があれば、ロード時にクラス付与
// body に $fixedHeader の高さを追加
$(window).on('load', function(){
  if ($fixedHeader.length > 0) {
    $fixedHeader.addClass(fixedClass);
    $body.css('padding-top', headerHeight);
  }
});